import React, {Suspense, lazy} from 'react';
import {Header} from '../../Components/Navbar/index';
import {TitleImage} from '../../Components/TitleImage';
import {Spinner} from 'react-bootstrap';
import {Helmet} from 'react-helmet';

const FormReferralCS = lazy(() => import('../../Components/FormReferralCS/index.js'));

const ReferralCS = () => {
  return (
    <>
      <div>
        <Helmet>
          <title>SADeaf Referral CS</title>
          <meta name="title" content="SADeaf Referral CS" />
          <meta name="description" content="SADeaf Referral CS" />
        </Helmet>
        <Header />
        <TitleImage title={'Referral CS'} />
        <Suspense
          fallback={
            <Spinner
              animation="border"
              variant="primary"
              className="m-auto d-flex justify-content-center align-items-center"
            />
          }>
          <FormReferralCS />
        </Suspense>
      </div>
    </>
  );
};

export default ReferralCS;
